import { DateRange } from 'owa-datetime-utils';
import { differenceInDays } from 'owa-datetime';

const DEFAULT_MAX_DAYS = 7;

export function getNumberOfDaysToLoad(
    loadedDateRange: DateRange | null,
    maxDaysToLoad: number | null
): number {
    if (!maxDaysToLoad) {
        return DEFAULT_MAX_DAYS;
    }
    const totalDaysLoaded = loadedDateRange
        ? differenceInDays(loadedDateRange.end, loadedDateRange.start)
        : 0;
    const daysLeftToLoad = maxDaysToLoad - totalDaysLoaded;
    return Math.min(daysLeftToLoad, DEFAULT_MAX_DAYS);
}
